import { Link, useNavigate } from "react-router-dom";
import { ShoppingBag, Search, Menu, X } from "lucide-react";
import { useCart } from "../context/CartContext";
import { useState } from "react";

export const Nav = () => {
  const { count } = useCart();
  const [menuOpen, setMenuOpen] = useState(false);
  const nav = useNavigate();

  return (
    <header className="glass-header fixed top-0 left-0 right-0 z-50" data-testid="main-nav">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12 h-20 flex items-center justify-between">
        <div className="flex items-center gap-10">
          <Link to="/" className="serif text-2xl tracking-[0.18em]" data-testid="nav-logo">
            VELORA<span className="font-light text-muted-foreground"></span>
          </Link>
          <nav className="hidden md:flex items-center gap-8 text-xs uppercase tracking-[0.22em]">
            <Link to="/shop/women" className="hover:text-muted-foreground transition" data-testid="nav-women">Women</Link>
            <Link to="/shop/men" className="hover:text-muted-foreground transition" data-testid="nav-men">Men</Link>
            <Link to="/shop/accessories" className="hover:text-muted-foreground transition" data-testid="nav-accessories">Accessories</Link>
            <Link to="/shop" className="hover:text-muted-foreground transition" data-testid="nav-shop-all">The Edit</Link>
          </nav>
        </div>
        <div className="flex items-center gap-5">
          <button
            className="hidden md:inline-flex hover:text-muted-foreground transition"
            data-testid="nav-search-btn"
            onClick={() => nav("/shop")}
            aria-label="Search"
          >
            <Search size={18} strokeWidth={1.2} />
          </button>
          <Link to="/cart" className="relative" data-testid="nav-cart-btn" aria-label="Cart">
            <ShoppingBag size={18} strokeWidth={1.2} />
            {count > 0 && (
              <span
                className="absolute -top-2 -right-2 text-[10px] bg-white text-black w-4 h-4 flex items-center justify-center tracking-tight"
                data-testid="cart-count"
              >
                {count}
              </span>
            )}
          </Link>
          <button
            className="md:hidden"
            onClick={() => setMenuOpen(!menuOpen)}
            data-testid="mobile-menu-btn"
            aria-label="Menu"
          >
            {menuOpen ? <X size={20} strokeWidth={1.2} /> : <Menu size={20} strokeWidth={1.2} />}
          </button>
        </div>
      </div>
      {menuOpen && (
        <div className="md:hidden border-t border-white/10 bg-black/90">
          <nav className="flex flex-col p-6 gap-4 text-xs uppercase tracking-[0.22em]">
            <Link to="/shop/women" onClick={() => setMenuOpen(false)} data-testid="mobile-nav-women">Women</Link>
            <Link to="/shop/men" onClick={() => setMenuOpen(false)} data-testid="mobile-nav-men">Men</Link>
            <Link to="/shop/accessories" onClick={() => setMenuOpen(false)} data-testid="mobile-nav-accessories">Accessories</Link>
            <Link to="/shop" onClick={() => setMenuOpen(false)} data-testid="mobile-nav-shop-all">The Edit</Link>
          </nav>
        </div>
      )}
    </header>
  );
};
